/**
 * HTML Entity Decoder Utility
 * Provides helper functions for decoding HTML entities in strings
 */
(function() {
  'use strict';

  /**
   * Decode HTML entities in a string
   * Handles entities like &apos; &quot; &amp; &#39; etc.
   *
   * @param {string} text - Text containing HTML entities
   * @return {string} Decoded text
   */
  function decodeHtmlEntities(text) {
    if (typeof text !== 'string') {
      return text;
    }

    // Create a temporary element to leverage browser's HTML parsing
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  /**
   * Recursively decode HTML entities in an object's string values
   *
   * @param {*} data - Data to decode (can be object, array, or primitive)
   * @return {*} Data with decoded strings
   */
  function decodeHtmlEntitiesRecursive(data) {
    if (typeof data === 'string') {
      return decodeHtmlEntities(data);
    }

    if (Array.isArray(data)) {
      return data.map(item => decodeHtmlEntitiesRecursive(item));
    }

    if (data !== null && typeof data === 'object') {
      const decoded = {};
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          decoded[key] = decodeHtmlEntitiesRecursive(data[key]);
        }
      }
      return decoded;
    }

    return data;
  }

  // Export to window for global access
  window.HtmlEntityDecoder = {
    decode: decodeHtmlEntities,
    decodeRecursive: decodeHtmlEntitiesRecursive
  };

})();
